import React from "react"

import { Switch, Route } from 'react-router-dom'

import Home from "../container/Home.js"
import Lobbyist from "../container/Lobbyist.js"
import Login from "../container/Login.js"
import ExportAnnualReturn from "../container/ExportAnnualReturn.js"
import AnnualReturn from "../container/AnnualReturn.js"
import ForgotPassword from "../container/ForgotPassword.js"
import ChangePassword from "../container/ChangePassword.js"
import SystemParameter from "../container/SystemParameter.js"
import AuditLog from "../container/AuditLog.js"

import Error401 from "../components/common/Error401"
import Error404 from "../components/common/Error404"

// Routes component is used to determine what component to render based on the url
// the { authProps } is an example of destructuring assignment where a property is retrieved from an object and stored in it's own variable
// in this case the object would be the props object

// NOTE: make sure any use of connect to connect to redux is not done on components that contain the routes otherwise this will break the routing
// i.e. make sure App or Main doesn't have connect
const Routes = () =>
      /* You can use the<Switch> component to group <Route>s. 
          The <Switch> will iterate over its children elements (the routes) 
          and only render the first one that matches the current pathname.
          info on router: https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf */
      <Switch>
        {/* 'exact' route must match path exactly */}
        <Route exact path='/' component={Home} />
        <Route exact path='/login' component={Login} />
        {/* 
            :lobbyistId indicates that this is a parameter passed in the url. This can then be accessed in the component by using this.props.match.params.lobbyistId
            The question mark indicates it is optional
        */}
        <Route path='/lobbyist/:lobbyistId?' component={Lobbyist} />
        <Route path='/change-password/:lobbyistId' component={ChangePassword} />
        <Route path='/annual-return/:lobbyistId/:annualReturnId?' component={AnnualReturn} />
        <Route path='/export-annual-return' component={ExportAnnualReturn} />
        <Route exact path='/forgot-password/:token?' component={ForgotPassword} />
        <Route exact path='/system-parameter' component={SystemParameter} />
        <Route exact path='/audit-log' component={AuditLog} />
        <Route exact path='/error/401' component={Error401} />
        <Route path='*' component={Error404} />

        {/* e.g. a route to match both /client and client/clientId
        note: not 'exact' */}
        {/* <Route path='/client' component={client}/> */}
      </Switch>

export default Routes



// WEBPACK FOOTER //
// ./src/routing/Routes.js